import { isPreQA, LabWorkbookStatus } from '@resistapp/common/types';

import { isSubmittedSampleLikeRow, type SampleSheetRowDraft } from './sample-sheet-data';

export type SampleSheetRowViewMode = 'draft' | 'submitted';

export function getInitialSampleSheetRowViewMode(
  labWorkbookStatus: LabWorkbookStatus | null | undefined,
): SampleSheetRowViewMode {
  return labWorkbookStatus === LabWorkbookStatus.LEGACY ? 'submitted' : 'draft';
}

export function getSampleSheetRowViewInstanceKey(
  labWorkbookId: string | null | undefined,
  labWorkbookStatus: LabWorkbookStatus | null | undefined,
): string {
  return `${labWorkbookId ?? 'unlinked'}:${getInitialSampleSheetRowViewMode(labWorkbookStatus)}`;
}

export function hasSubmittedRowsEligibleForEditing(
  rows: readonly Pick<SampleSheetRowDraft, 'isSubmittedSample' | 'isReadOnly' | 'sampleId' | 'status'>[],
): boolean {
  return rows.some(row => isSubmittedSampleLikeRow(row) && isPreQA(row.status));
}
